
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 11.667v-2.5h-2.5V7.5H15V5h1.667v2.5h2.5v1.667h-2.5v2.5H15zM7.5 10a3.21 3.21 0 01-2.354-.98 3.21 3.21 0 01-.98-2.353c0-.917.327-1.702.98-2.355A3.21 3.21 0 017.5 3.333a3.21 3.21 0 012.354.98 3.21 3.21 0 01.98 2.354 3.21 3.21 0 01-.98 2.354A3.21 3.21 0 017.5 10zM.833 16.667v-2.334c0-.472.122-.906.365-1.302a2.43 2.43 0 01.969-.906 12.37 12.37 0 012.625-.969 11.464 11.464 0 012.708-.323c.917 0 1.82.108 2.708.323a12.37 12.37 0 012.625.969c.403.208.726.51.97.906.242.396.364.83.364 1.302v2.334H.833z"}})])
          )
        }
      }
    